import $ from 'jquery';

/**
 * Helper for rendering PDFs using VPS Iframe
 * 
 * Assumptions:
 * 
 */
 export class RenderHomesiteInformationHelper {    
    /**
     * Constructor
     * @param {*} vpsIframeElem Element pointing to VPS Iframe
     * @param {*} vpsIframeSrc URL to use for VPS Iframe
     */
    constructor(vpsIframeElem, vpsIframeSrc){
        this._last_known_scroll_position = 0;
        this._ticking =  false;

        this._vpsApi = null;

        this._vpsIframe = vpsIframeElem;
        this._vpsIframeSrc = vpsIframeSrc;
        this._vpsIframeProxy = null;

        // Internet Explorer 6-11
        this._isIE= /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        this._isEdge= !this._isIE && !!window.StyleMedia;
    }
    /**
     * Functions
     */
    loadIframeContent(scroll_pos) {
        // Make sure to execute this once
        if (!this._ticking)
        {
            var DEFER_LOADING_THRESHOLD_START = 400;
            var DEFER_LOADING_THRESHOLD_END = 900;

            var hT = this._vpsIframe.offset() ? this._vpsIframe.offset().top : 0;
            var hH = this._vpsIframe.outerHeight() ? this._vpsIframe.outerHeight() : 0;
            var wH = $(window).height(),
                wS = $(window).scrollTop() + DEFER_LOADING_THRESHOLD_START;

            // Load the iframe content when the scroll position is on that section
            if (wS > (hT + hH - wH) && wS < (hT + hH + DEFER_LOADING_THRESHOLD_END - wH)) {

                let iframeHtml = this._vpsIframe[0];
                if (iframeHtml != null && iframeHtml != undefined) {
                    this._vpsApi = new VpsApi(iframeHtml); // Iframe object 
                    if (this._vpsApi != null && this._vpsApi != undefined) {
                        this.processIframeUrl();
                        this._ticking = true;
                    }
                }
            }
        }
    }
    
    processIframeUrl() {
        let _this = this;

        // do not update the last scroll position so we can restore it after load
        window.showPreLoader($("#site-map"));
        $(this._vpsIframe).on("load", function(){
            $(this).css("visibility", "visible");

            // need toi prevent the browser from auto scrolling to the iframe when it is loaded
            // instead overwrite this behavior by scrolling back to the last known scroll position
            window.scrollTo(0, _this._last_known_scroll_position);

            window.hidePreLoader($("#site-map"));
        });

        $.post({
            url: '/sheahomesapi/favorites/uid/',
            dataType: 'json'
        }).done(function (data) {
            let nodeGUID = $("#hfNodeGuid").val();
            let documentID = $("#hfDocumentId").val();
            let sessionID = $("#hfSessionID").val();
            let cookieUrl = _this.readCookie("vpsSessionUrl-" + documentID).trim();

            if (cookieUrl != '') {
                // Add To Favorites. Make MVC request to favorite the community
                $.post({
                    url: '/sheahomesapi/favorites/plan/add/' + nodeGUID,
                    dataType: 'json'
                }).done(function (data2) {
                    cookieUrl = _this.getProperApiUrl(cookieUrl);

                    // Refresh IFrame
                    if (data != null && data.uid != null && data.uid != '') {
                        _this._vpsIframe.attr("src", cookieUrl + '&userId=' + data.uid);
                    }
                    else {
                        _this._vpsIframe.attr("src", cookieUrl);
                    }
                    _this.deleteCookie("vpsSessionUrl-" + documentID);
                }).fail(function () {
                }).always(function () {
                });
            } else {
                let src = $("#hfVPSIframeSrc").val().trim();
                if (src != '') {
                    src = _this.getProperApiUrl(src);

                    if (data != null && data.uid != null && data.uid != '') {
                        src = src + '&userId=' + data.uid;

                        if (sessionID !== null && sessionID !== "") {
                            src += "&sessionId=" + sessionID;
                        }
                    }
                    _this._vpsIframe.attr("src", src);
                }
            }
        }).fail(function () {
        }).always(function () {
        });
     }

     getProperApiUrl(url) {
         let avUrl = $("#hfAVFloorPlanUrl").val();

         if (url.startsWith(avUrl) || url.toLowerCase().indexOf("secure.alpha-vision.com") < 0) {
             return url;
         }
         else if (url.startsWith("https")) {
             let urlSegments = url.split("?");

             if (urlSegments.length == 2) {
                 avUrl += "?" + urlSegments[1];
             }
         }
         else {
             avUrl += url;
         }

         return avUrl;
     }

    getVsApiInstance() {
        return this._vpsApi;
    }

    initSaveFloorPlan(buttons) {
        let _this = this;
        const SIGNIN_MODAL_ID = "signin-modal";
        const SAVE_FLOOR_PLAN_MODAL_ID = "save-floor-plan-modal";
        const CLICK_FAVORITE_BUTTON_EVENT = "click.favoriteButton";
        // Grab references to all buttons or to specific buttons if the buttons parameter is not null
        let favButtons = $('.floor-plan-save-button');
        if (buttons != null) {
            favButtons = buttons;
        }

        $(favButtons).each(function (index, button) {
            // Handle click events and update attributes as needed
            $(button).off(CLICK_FAVORITE_BUTTON_EVENT).on(CLICK_FAVORITE_BUTTON_EVENT, function (e) {
                e.preventDefault();

                let btn = $(this);
                let isUserAuthorized = btn.attr("aria-controls") === "signin-modal" ? false : true;
                let type = btn.data("type");
                let nodeGUID = btn.data("node-guid");
                let sessionId = $("#hfSessionID").val();

                if (!isUserAuthorized) {
                    _this.saveFPSession(sessionId, SIGNIN_MODAL_ID);
                }
                else {
                    // Make MVC request to favorite the community
                    $.post({
                        url: '/sheahomesapi/favorites/' + type + '/add/' + nodeGUID,
                        dataType: 'json'
                    }).done(function (data) {
                        _this.saveFloorPlanOnClick(data.uid, sessionId, SAVE_FLOOR_PLAN_MODAL_ID);

                        // Look for each button with this node guid
                        let buttons = $(".card-like-button[data-node-guid='" + nodeGUID + "'], .like-button[data-node-guid='" + nodeGUID + "']");
                        buttons.each(function(index, button){
                            window.updateFavoriteButtonState(button, true, nodeGUID,data.numfavcomms, true);
                        });
                    }).fail(function () {
                    }).always(function () {
                    });
                }
            });
        });
    }
    
    saveFPSession(sessionId, modalId) {
        this._vpsApi.saveConfig(sessionId, "", "callBackSaveFPSession");
        // Open the unfavorite modal (no need to set attributes since this should have been handled in BE)
        $("#" + modalId).foundation('open');
    }

    callBackSaveFPSession(url) {
        let documentID = $("#hfDocumentId").val();
        this.writeCookie("vpsSessionUrl-" + documentID, url);
        console.log(readCookie("vpsSessionUrl-" + documentID));
    }

    saveFloorPlanOnClick(uid, sessionId, modalId) {
        this._vpsApi.saveConfig(sessionId, uid, "callBackSaveFloorPlanOnClick");
        // Open the favorite modal
        $("#" + modalId).foundation('open');
    }

    callBackSaveFloorPlanOnClick(url) {
        console.log(url);
    }

    writeCookie(name, value) {
        document.cookie = name + "=" + value + "; path=/";
    }

    readCookie(name) {
        let i, c, ca, nameEQ = name + "=";
        ca = document.cookie.split(';');
        for (i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
};
